import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { validateCustomerAddressForm } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';
import Box from '@mui/material/Box';
import { Radio, Checkbox, Table, TableRow, TableCell, TableBody, TableFooter, FormControl, Tab } from '@material-ui/core';
import { ROLE_CUSTOMER } from '../../utils/config/constants';
import withUser from '../HOC/HOCwithUser.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import Geosuggest from 'react-geosuggest';
import { store } from '../../store';
import { userDetail } from '../../apiHelpers/user/detail';
const style = {
    width: '100%',
    height: '100%'
};
class CustomerAddressCreate extends React.Component {
    constructor(props) {
        console.log("Dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",props)
        super();
        this.state = {
            error: '',
            address_line1: '',
            address_line1Error: '',
            city: '',
            cityError: '',
            state: '',
            stateError: '',
            country: '',
            countryError: '',
            pincode: '',
            pincodeError: '',
            phone: props.userData.phone ? props.userData.phone : '',
            phoneError: '',
            name: props.userData.name ? props.userData.name : '',
            nameError: '',
            emailError: '',
            email: props.userData.email ? props.userData.email : '',
            loader: false,
            pass: false,
            noResponse: false,
            errorMessage: '',
            latitude: '40.730610',
            longitude: '-73.935242',
            type_id: 1,
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            addressAdded: false,
            centerLat: 40.730610,
            centerLng: -73.935242,
            is_default: false,
            added: false,
            buttonLoader: false,
            booking_data: props.history.location.booking_data,
            taskData: props.history.location.taskData,
            loginPath: props.history.location ? props.history.location.loginPath : '',
            value: props.history.location ? props.history.location.value : '',
            loginpathnew: props.location.state ? props.location.state.loginPath: '',
            booking_data_new: props.location.state ? props.location.state.booking_data:'',
            task_data_new: props.location.state ? props.location.state.taskData:'',
            taskDataFromConfirmPage: props.location.state ? props.location.state.taskDataFromConfirmPage:''
        };
    }

    componentDidMount() {
        this.getPlace(this.state.centerLat, this.state.centerLng);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.setState(
                    {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    },
                    () => {
                        this.getPlace(
                            position.coords.latitude,
                            position.coords.longitude
                        );
                        return true;
                    }
                );
            });
        } else {
            error => console.log(error);
        }
    }

    submit = params => {
        const {
            address_line1,
            city,
            state,
            country,
            pincode,
            name,
            email,
            phone,

            type_id,
            is_default
        } = this.state;
        if (
            validateCustomerAddressForm(
                {
                    address_line1,
                    city,
                    state,
                    country,
                    pincode,
                    name,
                    email,
                    phone
                },
                this.handleError
            )
        ) {
            this.setState({ loader: true });
            this.props.addAddressAction(
                {
                    address_line1,
                    city,
                    state,
                    country,
                    zipcode: this.state.pincode,
                    name,
                    email,
                    phone,
                    latitude: this.state.latitude
                        ? this.state.latitude
                        : this.state.centerLat,
                    longitude: this.state.longitude
                        ? this.state.longitude
                        : this.state.centerLng,
                    type_id,
                    is_default
                },
                this.onDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        }
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = async (success, data) => {
        this.setState({ loader: false });

        // if ( success) {
        //     NotificationManager.success(data.message, 'Success');
        //     const res = await userDetail();

        //     if (res.data.detail.approved) {
        //       this.props.history.push({ pathname: `/user/address` });
        //     } else {
        //       this.props.history.push({ pathname: `/user/profile/initial` });
        //     }
        const res = await userDetail();
        console.log("aqqqqqqqqqqqqqq1", res);
        // if (success && this.state.loginpathnew === "BookingConfirmAdressSignIn") {
        //     // If loginPath is 'BookingConfirmPaymentLogin', push to '/user/booking_confirm'
        //     this.props.history.push(`/user/booking_confirm`, {
        //         taskData: this.state.task_data_new,
        //         booking_data: this.state.booking_data_new
        //     });
        // }

        if (success && this.state.loginPath === 'BookingConfirmAdressUpdate') {
            NotificationManager.success(data.message, 'Success');
            this.props.history.push(`/user/booking_confirm`, {
                taskData: this.state.taskData,
                booking_data: this.state.booking_data,
                taskDataFromConfirmPage: this.props.history.location.taskDataFromConfirmPage,
                BookingPath: this.props.history.location.BookingPath,
                taskDataFromConfirmPage: this.props.history.location.taskDataFromConfirmPage
            })
        }else if(success && this.state.loginPath === 'BookingConfirmAdressAdd' ){
            NotificationManager.success(data.message, 'Success');
            this.props.history.push(`/user/booking_confirm`, {
                taskData: this.state.taskData,
                booking_data: this.state.booking_data,
                taskDataFromConfirmPage: this.props.history.location.taskDataFromConfirmPage,
                BookingPath: this.props.history.location.BookingPath,
                taskDataFromConfirmPage: this.props.history.location.taskDataFromConfirmPage
            })
        }
        else if (success && res.data.detail.approved) {
            this.props.history.push({ pathname: `/user/address` });
        }
        else if(success && this.state.loginpathnew === "BookingConfirmAdressSignIn"){
            NotificationManager.success(data.message, 'Success');

            this.props.history.push(`/user/booking_confirm`, {
                taskData: this.state.task_data_new,
                booking_data: this.state.booking_data_new,
                taskDataFromConfirmPage: this.state.taskDataFromConfirmPage,
                BookingPath: this.props.location.state.BookingPath
            });
        }else if(success ){
            NotificationManager.success(data.message, 'Success');
            this.props.history.push(`/user/profile/initial`);
        }
    };
    handleRadioChange = event => {
        this.setState({ type_id: event.target.value });
    };
    renderButton = () => {
        if (this.state.loader) {
            return <CircularProgress />;
        }
        return (
            <button

                className="custom-button"

                onClick={this.submit}
            >
                ADD
            </button>
        );
    };
    onMarkerClick = (props, marker, e) => {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };
    onMarkerDragEnd = (coord, index) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();

        this.setState({ latitude: lat, longitude: lng }, () => {
            this.getPlace(lat, lng);
        });
    };

    getPlace = async (lat, lng) => {
        var latLng = parseFloat(lat) + ',' + parseFloat(lng);

        const { data } = await axios({
            url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng}&key=${this.props.settings.constants.GOOGLE_MAP_KEY}`
        });

        if (data.status === 'OK') {
            if (data.results[0].formatted_address) {
                this.setState({
                    address_line1: data.results[0].formatted_address
                });
            }
            data.results[0].address_components.map(address => {
                if (address.types.includes('country')) {
                    this.setState({ country: address.long_name });
                } else if (address.types.includes('postal_code')) {
                    // pincode = address.long_name;
                    this.setState({ pincode: address.long_name });
                } else if (
                    address.types.includes('administrative_area_level_1')
                ) {
                    this.setState({ state: address.long_name });
                } else if (
                    address.types.includes('administrative_area_level_2') ||
                    address.types.includes('locality')
                ) {
                    this.setState({ city: address.long_name });
                }
            });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="googleApiNotWorking"
                    defaultMessage="Google Api not working, Please add address manually"
                />,
                'Error'
            );
        }
    };
    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    handleSelectPlace = event => {
        if (event) {
            this.setState(
                {
                    latitude: event.location.lat,
                    longitude: event.location.lng,
                    centerLat: event.location.lat,
                    centerLng: event.location.lng
                },
                () => {
                    this.getPlace(event.location.lat, event.location.lng);
                }
            );
        }
    };

    render() {
        const {
            address_line1,
            city,
            state,
            country,
            pincode,
            name,
            email,
            phone,
            loader,
            address_line1Error,
            cityError,
            stateError,
            countryError,
            pincodeError,
            phoneError,
            emailError,
            nameError,
            latitude,
            longitude
        } = this.state;
        const { userData } = this.props;
        console.log("aaaaaaaaaawssddddd", this.state)
        console.log("qqqqqqqqqq", this.props.history.location.taskDataFromConfirmPage)
        const { formatMessage } = this.props.intl;
        return (
            <Card className="col-md-12">
                <div>
                    <h4>
                        <b>
                            <FormattedMessage
                                id="markerNote"
                                defaultMessage="Note: Drag red marker on map to fetch location"
                            />
                        </b>
                    </h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div style={{ height: 300 }}>
                            <Map
                                centerAroundCurrentLocation={true}
                                style={style}
                                google={this.props.google}
                                zoom={7}
                                center={{
                                    lat: latitude,
                                    lng: longitude
                                }}
                            >
                                <Marker
                                    position={{
                                        lat: latitude,
                                        lng: longitude
                                    }}
                                    draggable={true}
                                    onDragend={(t, map, coord) =>
                                        this.onMarkerDragEnd(coord)
                                    }
                                />

                                {/* <InfoWindow
                                    onClose={this.onInfoWindowClose}
                                    marker={this.state.activeMarker}
                                    visible={this.state.showingInfoWindow}
                                >
                                    <div>
                                        <h1>{this.state.selectedPlace}</h1>
                                    </div>
                                </InfoWindow> */}
                            </Map>
                        </div>
                    </div>
                </div>
                <div>
                    <Geosuggest
                        suggestItemClassName="autosuggest-places"
                        onSuggestSelect={this.handleSelectPlace}
                        placeholder="Search Address or Drag red Marker in Map"
                    />
                </div>
                <div className="custom-input-text">
                    <Box width='100%'>
                        <Table className="table bordered custom-input-text" >



                            <TableBody>
                                {/* name */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dsfa"
                                            defaultMessage="Name:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={nameError ? true : false}
                                                helperText={nameError}
                                                type="text"
                                                name="name"
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'name'
                                                })}
                                                id="name"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'name'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                margin="normal"
                                                onChange={event => {
                                                    this.setState({
                                                        name: event.target.value,
                                                        nameError: ''
                                                    });
                                                }}
                                                value={name}
                                                //defaultValue={name}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>
                                </TableRow>
                                {/* Email  */}
                                <TableRow>

                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfas"
                                            defaultMessage="Email:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={emailError ? true : false}
                                                helperText={emailError}
                                                type="email"
                                                name="email"
                                                label={formatMessage({
                                                    id: 'email'
                                                })}
                                                id="email"
                                                className="login-form-textfield"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'email'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onChange={event => {
                                                    this.setState({
                                                        email: event.target.value,
                                                        emailError: ''
                                                    });
                                                }}
                                                margin="normal"
                                                //defaultValue={email}
                                                value={email}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>


                                </TableRow>

                                {/* Mobile */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfasss"
                                            defaultMessage="Mobile:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={phoneError ? true : false}
                                                helperText={phoneError}
                                                type="text"
                                                name="phone"
                                                label={formatMessage({
                                                    id: 'phone'
                                                })}
                                                id="phone"
                                                fullWidth
                                                className="login-form-textfield"
                                                placeholder={formatMessage({
                                                    id: 'phone'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onChange={event => {
                                                    this.setState({
                                                        phone: event.target.value,
                                                        phoneError: ''
                                                    });
                                                }}
                                                margin="normal"
                                                value={phone}
                                                // defaultValue={phone}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>
                                </TableRow>

                                {/* address  */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfssssadress"
                                            defaultMessage="Address:"
                                        />
                                    </TableCell>

                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                style={{ padding: "13px 0 0 0", borderTop: "1px solid #0078ff", fontWeight: "600" }}
                                                error={address_line1Error ? true : false}
                                                helperText={address_line1Error}
                                                type="text"
                                                name="address_line1"
                                                label={formatMessage({
                                                    id: 'address'
                                                })}
                                                className="login-form-textfield"
                                                id="address_line1"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'address'
                                                })}
                                                multiline
                                                rows={2}
                                                maxRows={Infinity}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                margin="normal"
                                                onChange={event => {
                                                    this.setState({
                                                        address_line1: event.target.value,
                                                        address_line1Error: ''
                                                    });
                                                }}
                                                value={address_line1}
                                                // defaultValue={address_line1}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>

                                </TableRow>

                                {/* City  */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfsscity"
                                            defaultMessage="City:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={cityError ? true : false}
                                                helperText={cityError}
                                                type="text"
                                                className="login-form-textfield"
                                                name="city"
                                                label={formatMessage({
                                                    id: 'city'
                                                })}
                                                id="city"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'city'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                margin="normal"
                                                onChange={event => {
                                                    this.setState({
                                                        city: event.target.value,
                                                        cityError: ''
                                                    });
                                                }}
                                                value={city}
                                                //defaultValue={city}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>

                                </TableRow>

                                {/* State  */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfssstate"
                                            defaultMessage="State:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={stateError ? true : false}
                                                helperText={stateError}
                                                type="text"
                                                name="state"
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'state'
                                                })}
                                                id="state"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'state'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                margin="normal"
                                                onChange={event => {
                                                    this.setState({
                                                        state: event.target.value,
                                                        stateError: ''
                                                    });
                                                }}
                                                value={state}
                                                //defaultValue={state}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>

                                </TableRow>

                                {/* Country  */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfscountry"
                                            defaultMessage="Country:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={countryError ? true : false}
                                                helperText={countryError}
                                                type="text"
                                                name="country"
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'country'
                                                })}
                                                id="country"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'country'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                margin="normal"
                                                onChange={event => {
                                                    this.setState({
                                                        country: event.target.value,
                                                        countryError: ''
                                                    });
                                                }}
                                                value={country}
                                                // defaultValue={country}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>

                                </TableRow>

                                {/* Zip Code  */}
                                <TableRow>
                                    <TableCell style={{ width: "27%", padding: "33px" }} className="text-left">
                                        <FormattedMessage
                                            id="dfszip"
                                            defaultMessage="ZIP Code:"
                                        />
                                    </TableCell>
                                    <TableCell style={{ padding: "0" }} className="text-left">
                                        <form className="form-new">
                                            <TextField
                                                error={pincodeError ? true : false}
                                                helperText={pincodeError}
                                                type="text"
                                                name="pincode"
                                                label={formatMessage({
                                                    id: 'pincode'
                                                })}
                                                id="pincode"
                                                className="login-form-textfield"
                                                fullWidth
                                                placeholder={formatMessage({
                                                    id: 'pincode'
                                                })}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                margin="normal"
                                                onChange={event => {
                                                    this.setState({
                                                        pincode: event.target.value,
                                                        pincodeError: ''
                                                    });
                                                }}
                                                value={pincode}
                                                //defaultValue={pincode}
                                                disabled={loader ? true : false}
                                            />
                                        </form>
                                    </TableCell>


                                </TableRow>

                            </TableBody>

                        </Table>
                    </Box>


                    {userData.role == ROLE_CUSTOMER && (
                        <div className="col-md-4 row">
                            <div className="col-md-4  addbtn">
                                <div className="row">
                                    <Radio
                                        checked={this.state.type_id == 1}
                                        onChange={event =>
                                            this.handleRadioChange(event)
                                        }
                                        value={1}
                                        color="primary"
                                    />
                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        <FormattedMessage
                                            id="home"
                                            defaultMessage="Home"
                                        />
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4 addbtn">
                                <div className="row">
                                    <Radio
                                        checked={this.state.type_id == 2}
                                        onChange={event =>
                                            this.handleRadioChange(event)
                                        }
                                        value={2}
                                        color="primary"
                                    />
                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        <FormattedMessage
                                            id="work"
                                            defaultMessage="Work"
                                        />
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4 addbtn">
                                <div className="row">
                                    <Radio
                                        checked={this.state.type_id == 3}
                                        onChange={event =>
                                            this.handleRadioChange(event)
                                        }
                                        value={3}
                                        color="primary"
                                    />
                                    <p style={{ display: "flex", alignItems: "center" }}>
                                        <FormattedMessage
                                            id="other"
                                            defaultMessage="Other"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="col-md-4">
                        <input type="checkbox" name="hello" />
                        <div className="row align-items-center">
                            <Checkbox
                                checked={this.state.is_default}
                                onChange={this.handleChange('is_default')}
                                value="is_default"
                                color="primary"
                            />
                            <p>
                                <FormattedMessage
                                    id="setAsOffice"
                                    defaultMessage="Set as Default"
                                />
                            </p>
                        </div>
                    </div>
                    <div style={{ marginBottom: "25px" }} className="col-md-12 col-xs-12 d-flex justify-content-center">
                        <div className="mt-3" />
                        {this.renderButton()}
                    </div>

                </div>
            </Card>
        );
    }
}

const composedComponent = compose(
    GoogleApiWrapper(props => ({
        apiKey: props.settings.constants.GOOGLE_MAP_KEY
    })),

    connect(null, actions)
);
export default composedComponent(withUser(injectIntl(withRouter(CustomerAddressCreate))));



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerAddressCreate.jsx